export interface MiningRuntimeOptions {
  gatewayUrl: string;
  ticket: string;
  threads: number;
  cpuPercent: number;
  onStatus: (message: string) => void;
  onHashrate: (hashesPerSecond: number) => void;
  onAcceptedShare: () => void;
  onStopped?: (message: string) => void;
}

export interface SilverdropMiningRuntime {
  start(options: MiningRuntimeOptions): Promise<void>;
  stop(): Promise<void> | void;
}

declare global {
  interface Window {
    SilverdropMiningRuntime?: SilverdropMiningRuntime;
  }
}

export function getMiningRuntime(): SilverdropMiningRuntime | null {
  return window.SilverdropMiningRuntime ?? null;
}
